import React from 'react';
import AdminPanel from './AllJobs /AllJobs';

function AllJobs() {
  return (
    <div>
      <AdminPanel />
    </div>
  );
}

export default AllJobs;
